import * as React from "react";
import Tabs from "@mui/material/Tabs";

import PropTypes from "prop-types";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import styled from "@emotion/styled";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { useContext } from "react";
import { WalletContext } from "../../../Pages/Dashborad";
import DashboardHome from "../DashboreadHome";
import WalletConnectCard from "../ConnectWalletCard";
import { Typography } from "@mui/material";
import SupplyHome from "../SupplyTab";
import MarketHome from "../MarketPage";
import BorrowHome from "../BorrowPage";

const TabTab = styled(Tab)`
  color: ${(props) => props.theme.textSecondary};
  border: 1px solid #fe9c02;
  background: transparent;
  padding: 5px 6px;
  margin: 0 10px;
  border-radius: 10px;
  min-height: 0;
  @media(max-width: 599){
    font-size: 12px;
  }

`;
const TABS = styled(Tabs)`
display: flex;
  @media(max-width: 510){
    flex-direction: column !important;
    align-items: center !important;
    justify-content: center !important;
    row-gap: 5px !important;
  }

`;


function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
export default function DashboardTabs() {
  const { connectState, setConnectState } = useContext(WalletContext);
  console.log(setConnectState)
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <Box sx={{ width: "100%" , minHeight:"calc(100vh - 142px)" ,padding:"0 !important"}}>
        <Box
          sx={{
            width: "100%",
            position: "relative",
            padding: "30px 0",
            zIndex: "9999999",
          }}
        >
          <TABS
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <TabTab
              icon={<DashboardIcon />}
              iconPosition="start"
              {...a11yProps(0)}
              label="Dashboard"
            />
            <TabTab {...a11yProps(1)} label="Market" />
            <TabTab
              {...a11yProps(2)}
              label="Supply"
              disabled={connectState ? false : true}
            />
            <TabTab
              {...a11yProps(3)}
              label="Borrow"
              disabled={connectState ? false : true}
            />
          </TABS>
        </Box>
        <CustomTabPanel value={value} index={0}>
          {connectState ? <DashboardHome /> : <WalletConnectCard />}
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <MarketHome/>
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          <SupplyHome />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={3}>
          <BorrowHome />
        </CustomTabPanel>
      </Box>
    </>
  );
}
